import { render, staticRenderFns } from "./ShoppingTitle.vue?vue&type=template&id=456a2ab4&scoped=true"
import script from "./ShoppingTitle.vue?vue&type=script&lang=js"
export * from "./ShoppingTitle.vue?vue&type=script&lang=js"
import style0 from "./ShoppingTitle.vue?vue&type=style&index=0&id=456a2ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a2ab4",
  null
  
)

export default component.exports